/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface SkinConditionInterface {
  "date": Date;
  "photosCount": number;
  "additionalPhotosCount": number;
  "id"?: any;
  "patientId"?: any;
  patient?: Patient;
}

export class SkinCondition implements SkinConditionInterface {
  "date": Date;
  "photosCount": number;
  "additionalPhotosCount": number;
  "id": any;
  "patientId": any;
  patient: Patient;
  constructor(data?: SkinConditionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SkinCondition`.
   */
  public static getModelName() {
    return "SkinCondition";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SkinCondition for dynamic purposes.
  **/
  public static factory(data: SkinConditionInterface): SkinCondition{
    return new SkinCondition(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SkinCondition',
      plural: 'SkinConditions',
      path: 'SkinConditions',
      idName: 'id',
      properties: {
        "date": {
          name: 'date',
          type: 'Date'
        },
        "photosCount": {
          name: 'photosCount',
          type: 'number',
          default: 0
        },
        "additionalPhotosCount": {
          name: 'additionalPhotosCount',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
